import * as React from "react";
import {Component} from "react";
import {connect} from "react-redux";
import DispatchProps from "../../utils/DispatchProps";
import ApiService from "../ApiService";
import {IRootState} from "../../store";
import H from "history";
import {Dictionary} from "lodash";
import LoadingPage from "../LoadingPage";
import {Bar, Doughnut} from "react-chartjs-2";
import {DEFAULT_CHART_COLOURS} from "../pages/admin/workloads/WorkloadResultsCharts";
import WorkloadOutputViewer from "../WorkloadOutputViewer";

interface MailroomReport
{
    schoolCount: number;
    items: any[];
    
    featureTotals: Dictionary<number>;
    misTotals: Dictionary<number>;
    dataServiceTotals: Dictionary<number>;
}

interface MailroomReportPageProps {
    apiService: ApiService;
    history: H.History;
    instanceId: string;
}

interface MailroomReportPageState {
    
    report?: MailroomReport;
}

class MailroomReportPage extends Component<MailroomReportPageProps & DispatchProps,MailroomReportPageState> {

    constructor(props: MailroomReportPageProps & DispatchProps) {
        super(props);

        this.state = {
            report: undefined
        };
    }

    async componentDidMount(): Promise<void> {
        
        const report = await this.props.apiService.getDurableFunctionInstanceOutput<MailroomReport>("mailroom",this.props.instanceId);
        console.log(report);
        this.setState({
            report
        });
    }

    async componentDidUpdate(prevProps: Readonly<MailroomReportPageProps & DispatchProps>, prevState: any): Promise<void>
    {

    }
    
    public render(): JSX.Element {
        
        if(this.state.report === undefined)
        {
            return (<LoadingPage></LoadingPage>);
        }

        const buildTotalsDonut = (title: string, totals: Dictionary<number>) =>
        {
            const labels = Object.keys(totals).filter(x => x !== "$type");
            const data = labels.map(label => totals[label]);

            return {
                title: title,
                labels: labels,
                datasets: [{
                    data: data,
                    backgroundColor: DEFAULT_CHART_COLOURS
                }]
            };
        };

        const featureNames = Object.keys(this.state.report.featureTotals).filter(x => x !== "$type");
        const featureData = featureNames.map((feature,i) => {
            return this.state.report?.featureTotals[feature];
        })


        const BAR_CHART_OPTIONS = {
            scales: {
                yAxes: [
                    {
                        ticks: {
                            beginAtZero: true,
                            
                            min: 0,
                            max: this.state.report.schoolCount
                        },
                    },
                ],
            },
        };
        
        const barChartDatasets =
        {
            labels: featureNames,
            datasets: [{
                label: "Number of schools with feature",
                data: featureData,
                backgroundColor: DEFAULT_CHART_COLOURS
            }]
        };
        
        
        return (
            <div className={"flex-column"}>
                
                <span>Mailroom report page ({this.props.instanceId})</span>

                <div className={"flex-row flex--justify-content-space-around"}>
                    <div className="doughnut-holder">
                        <Doughnut data={buildTotalsDonut("Data Service", this.state.report.dataServiceTotals)} height={1} width={1}/>
                    </div>
                    <div className="doughnut-holder">
                        <Doughnut data={buildTotalsDonut("Mis", this.state.report.misTotals)} height={1} width={1}/>
                    </div>
                </div>

                <Bar data={barChartDatasets} width={4} height={1} options={BAR_CHART_OPTIONS}/>
                
                <WorkloadOutputViewer title={"Full Report Output"} jsonObject={this.state.report}/>

            </div>
        );
    }
}

export default connect(
    (state: IRootState, ownProps: any): MailroomReportPageProps => {

        return {
            instanceId: ownProps.match.params.instanceId,
            history: state.history,
            apiService: state.auth.apiService
        };

    }
)(MailroomReportPage)